export const accountTypeList = [
  {
    label: '试用账户',
    value: 'demo',
  },
  {
    label: '正式账户',
    value: 'normal',
  },
  {
    label: '内部账户',
    value: 'internal',
  },
]

export const getLimitNum = (limit) => {
  return limit === -1 ? '无限制' : limit
}

export const statusList = [
  {
    value: 'active',
    label: '使用中',
  },
  {
    value: 'disable',
    label: '已过期',
  },
  {
    value: 'unactive',
    label: '未使用',
  },
]

export const authStatusList = [
  {
    value: 'active',
    label: '生效中',
  },
  {
    value: 'disable',
    label: '已失效',
  },
  {
    value: 'unactive',
    label: '待生效',
  },
]

// 1是 2否 0全部
export const freeList = [
  // {
  //   value: 0,
  //   label: '全部'
  // },
  {
    value: 2,
    label: '是',
  },
  {
    value: 1,
    label: '否',
  },
]

// 是否测试账号
export const testList = [
  {
    value: 1,
    label: '是',
  },
  {
    value: 2,
    label: '否',
  },
]
